module.exports = __webpack_public_path__ + "static/img/Opportunities_Visiting_Speakers_2.6547f37.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Opportunities_Visiting_Speakers_2.jpg
// module id = b9Z5
// module chunks = 1